export default __webpack_public_path__ + "bdff580949ee0762c9f243db6ac1e54d.svg";